import React, { useState, useCallback, useLayoutEffect, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import bowser from 'yola-bowser';
import { designSystem } from '@yola/ws-ui';
import { i18next } from '@yola/ws-sdk';

const { SearchableSelect } = designSystem;

const useOptionsLoader = (loadOptions, value) => {
  const componentMountedRef = useRef(true);
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState(null);

  useEffect(
    () => () => {
      componentMountedRef.current = false;
    },
    []
  );

  useLayoutEffect(() => {
    if (options) {
      const targetOption = options.find((option) => option.value === value) || options[0];

      setSelectedOption(targetOption);
    }
  }, [options, value]);

  const optionsLoader = useCallback(
    () =>
      loadOptions().then((data) => {
        if (componentMountedRef.current) {
          setOptions(data);
        }

        return data;
      }),
    [loadOptions]
  );

  return { optionsLoader, selectedOption };
};

function AsyncDropdownItem({ value = '', loadOptions, onChange, ...otherProps }) {
  const { selectedOption, optionsLoader } = useOptionsLoader(loadOptions, value);

  return (
    <SearchableSelect
      {...otherProps}
      className="ws-async-dropdown-item"
      value={selectedOption}
      asyncConfig={{
        loadOptions: optionsLoader,
        cacheOptions: true,
        defaultOptions: true,
      }}
      menuPlacement={bowser.mobile || bowser.tablet ? 'bottom' : 'auto'}
      noResultsText={i18next.t('No result')}
      clearable={false}
      onChange={onChange}
    />
  );
}

AsyncDropdownItem.propTypes = {
  value: PropTypes.string,
  loadOptions: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};
export default AsyncDropdownItem;
